import type { ReactElement } from 'react';
import closeIconSvg from '@shared/icons/Close-icon.svg';

interface IconCloseProps {
  size?: number;
  className?: string;
  'aria-label'?: string;
  'aria-hidden'?: boolean;
}

export const IconClose = ({
  size = 20,
  className,
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
}: IconCloseProps): ReactElement => (
  <img
    src={closeIconSvg}
    width={size}
    height={size}
    className={className}
    aria-label={ariaLabel}
    aria-hidden={ariaHidden}
    role={ariaLabel ? 'img' : undefined}
    alt=""
  />
);
